module.exports = __webpack_public_path__ + "img/features_header_laporan.fc47ca36.png";